import { h, render, Fragment } from 'preact';
import { useState, useEffect, useRef } from 'preact/hooks';

import ProductComponent from '../ProductComponent';
// eslint-disable-next-line no-unused-vars

import './product-gallery.css';

export default (element, data) => {
  const body = document.querySelector('body');

  const productGalleryWrapper = element.querySelector(
    '[data-target="product-gallery-wrapper"]',
  );

  const wearItWith = element.querySelector('[data-target="wear-it-with"]');
  const productThumbnails = element.querySelector(
    '[data-target="product-thumbnails"]',
  );

  const WearItWith = ({ products, sectionId }) => (
    <>
      {products.map((product, index) =>
        product.available ? (
          <ProductComponent
            key={index}
            product={product}
            sectionId={sectionId}
            quantityInput="false"
          />
        ) : null,
      )}
    </>
  );

  const ProductGalleryImages = ({ model, images }) => {
    if (!images) {
      return null; // Return null or fallback content when images is undefined
    }
    return (
      <>
        {images.map((image, index) => (
          <div
            key={index}
            className="relative col-span-1 aspect-[462/580] w-[320px] flex-shrink-0 snap-start lg:w-auto"
          >
            <a
              className="venobox"
              data-gall="product-gallery"
              href={image.large}
            >
              <picture className="absolute inset-0 z-0">
                <source
                  srcSet={image.small}
                  media="(max-width: 1023px)"
                />
                <source
                  srcSet={image.medium}
                  media="(max-width: 1023px)"
                />

                {index === 0 && model && (
                  <span className="absolute bottom-20 z-1 w-full text-center">
                    <span className="body-3 rounded-5 bg-gray-400 px-16 py-8">
                      {model}
                    </span>
                  </span>
                )}

                <img
                  loading="eager"
                  src={image.medium}
                  alt={image.alt}
                  width="auto"
                  height="auto"
                  className="cover absolute inset-0 block h-full w-full cursor-zoom-in object-cover object-center"
                />
              </picture>
            </a>
          </div>
        ))}
      </>
    );
  };

  const ProductGallery = ({ images: { variantImages, colorGroupImages } }) => {
    const [selectedVariant, setSelectedVariant] = useState();
    const [modelBadge, setModelBadge] = useState();
    const productGalleryRef = useRef(null);
    const venoBoxInstanceRef = useRef(null);

    useEffect(() => {
      const setNewImages = (id) => {
        const selectedVariantId = id; // Access the dispatched event value

        if (selectedVariantId) {
          const variant = variantImages[selectedVariantId];
          const model = variant?.model;
          const selectedVariantImages = variant?.images || [];
          const selectedVariantColor = variant?.color;
          const selectedVariantColorImages =
            colorGroupImages[selectedVariantColor] || [];

          setModelBadge(model);

          setSelectedVariant(
            selectedVariantImages.length > 0
              ? selectedVariantImages
              : selectedVariantColorImages,
          );
        } else {
          const colorDiv = element.querySelector('[data-option="Color"]');
          const checkedRadio = colorDiv?.querySelector(
            'input[type="radio"]:checked',
          );

          setSelectedVariant(
            checkedRadio ? colorGroupImages[checkedRadio.value] : [],
          );
        }

        // window.scrollTo({ top: 0, behavior: 'smooth' });
      };

      const handleFormChange = (event) => {
        setNewImages(event.detail?.id);
        document
          .querySelectorAll('[data-option="Color"] label.cursor-pointer')
          .forEach((label) => {
            label.addEventListener('click', () => {
              productGalleryWrapper.querySelector('div').scrollLeft = 0;
            });
          });
      };

      setNewImages(data.selectedOrFirstAvailableVariant);
      productGalleryWrapper.addEventListener('form:change', handleFormChange);

      return () => {
        productGalleryWrapper.removeEventListener(
          'form:change',
          handleFormChange,
        );
      };
    }, [data.selectedOrFirstAvailableVariant, variantImages, colorGroupImages]);

    useEffect(() => {
      venoBoxInstanceRef.current = null; // Reset the VenoBox instance

      if (selectedVariant && productGalleryRef.current) {
        // Initialize VenoBox only if there is a selected variant and the productGalleryRef is available
        venoBoxInstanceRef.current = new window.VenoBox({
          selector: '.venobox',
          numeration: true,
          infinigall: true,
          share: true,
          toolsColor: '#000000',
          overlayColor: 'rgba(0, 0, 0, 0.5)',
          toolsBackground: '#ffffff',
          spinner: 'rotating-plane',
          ratio: 'full',
          overlayClose: false,
          onContentLoaded() {
            const content = document.querySelector('.vbox-child');
            if (content) {
              const buttons = [
                createButton(
                  'vbox-close-button',
                  venoBoxInstanceRef.current.close,
                ),
                createButton(
                  'vbox-next-button',
                  venoBoxInstanceRef.current.next,
                ),
                createButton(
                  'vbox-prev-button',
                  venoBoxInstanceRef.current.prev,
                ),
              ];

              appendButtons(content, buttons);
            }
          },
        });
      }
    }, [selectedVariant]);

    return (
      <div
        ref={productGalleryRef}
        data-target="product-gallery"
        className="scrollbar-hide flex snap-x gap-10 overflow-x-auto scroll-smooth lg:grid lg:grid-cols-2 lg:gap-8"
      >
        <ProductGalleryImages
          images={selectedVariant}
          model={modelBadge}
        />
      </div>
    );
  };

  const ProductThumbnails = ({ thumbnailsData }) => {
    const [images, setImages] = useState(
      thumbnailsData &&
        thumbnailsData[`${data.selectedOrFirstAvailableVariant}`],
    );
    const handleFormChange = (event) => {
      setImages(thumbnailsData[event.detail?.id]);
    };

    productThumbnails.addEventListener('form:change', handleFormChange);

    return (
      <div className="flex gap-16">
        {images?.map((img, index) => (
          <picture key={index}>
            <source
              srcSet={img}
              media="(max-width: 1023px)"
            />
            <source
              srcSet={img}
              media="(max-width: 1023px)"
            />

            <img
              loading="eager"
              src={img}
              width="auto"
              height="auto"
              className="h-full w-[50px] min-w-[50px] rounded-[5px] object-cover"
            />
          </picture>
        ))}
      </div>
    );
  };

  const init = () => {
    setTimeout(() => {
      setEmptyFormHeight();
    }, 0);
    window.document.addEventListener('scroll', atcSticky);

    window.addEventListener('resize', () => {
      removeAtcStickky();
      setEmptyFormHeight();
    });

    if (wearItWith) {
      render(
        <WearItWith
          products={data.wearItWithProductData}
          sectionId={data.sectionId}
        />,
        wearItWith,
      );
    }

    if (productGalleryWrapper) {
      render(
        <ProductGallery
          images={data.images}
          defaultVaraint={data.selectedOrFirstAvailableVariant}
        />,
        productGalleryWrapper,
      );
    }

    if (productThumbnails) {
      render(
        <ProductThumbnails thumbnailsData={data.thumbnailsData} />,
        productThumbnails,
      );
    }
  };
  const createButton = (className, clickHandler) => {
    const button = document.createElement('div');
    button.classList.add(className);
    button.addEventListener('click', clickHandler);
    return button;
  };

  const appendButtons = (parent, buttons) => {
    parent.append(...buttons);
  };

  const removeAtcStickky = () => {
    body.classList.remove('atc-sticky');
  };

  const atcSticky = () => {
    const addToCartWrapper = element.querySelector(
      '[data-target="sticky-atc-trigger"]',
    );

    if (!addToCartWrapper) return;

    const topOffset = addToCartWrapper.getBoundingClientRect().top;
    const enableDesktopStickyATC =
      window?.TMW?.global_settings?.enableDesktopStickyATC || false;

    if (
      (enableDesktopStickyATC || window.innerWidth < 1024) &&
      topOffset <= 0
    ) {
      body.classList.add('atc-sticky');
    } else {
      body.classList.remove('atc-sticky');
    }
  };

  const setEmptyFormHeight = () => {
    const wrapper = element.querySelector('[data-empty-form]');
    const form = element.querySelector('#add-to-cart-form');
    if (!wrapper || !form) return;
    const height = form.offsetHeight;
    wrapper.style.height = `${height}px`;
  };

  const venobox = new window.VenoBox({
    selector: '.venobox',
    numeration: true,
    infinigall: true,
    share: true,
    toolsColor: '#000000',
    toolsBackground: '#ffffff',
    spinner: 'rotating-plane',
    ratio: 'full',
    overlayClose: false,
    onContentLoaded() {
      const content = document.querySelector('.vbox-child');
      if (content) {
        const buttons = [
          createButton('vbox-close-button', venobox.close),
          createButton('vbox-next-button', venobox.next),
          createButton('vbox-prev-button', venobox.prev),
        ];

        appendButtons(content, buttons);
      }
    },
  });

  init();
};
